module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=ST - Sao Tome and Principe.bc25dba4.svg";